import Paper from '@mui/material/Paper'
import TextField from '@mui/material/TextField'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { add } from 'date-fns'
import { useContext } from 'react'
import { inputContext } from '../../../../../context/inputsContext'

const MonthPicker = () => {
  const { values, setValues } = useContext(inputContext)

  return (
    <Paper elevation={0}>
      <DatePicker
        views={['year', 'month']}
        minDate={new Date('2018-01-01')}
        maxDate={new Date(Date.now())}
        defaultCalendarMonth={new Date(add(Date.now(), { months: -1 }))}
        value={values.reportDate}
        onChange={(newValue) => {
          if (!newValue) return
          setValues((c) => {
            const date = {
              reportDate: Date.UTC(
                newValue.getUTCFullYear(),
                newValue.getUTCMonth(),
                1,
              ),
            }
            return { ...c, ...date }
          })
        }}
        renderInput={(params) => <TextField {...params} helperText={null} />}
      />
    </Paper>
  )
}

export default MonthPicker
